const initialState = {
    isReadingHistory: false,
    history: [],
    history_count: 0
}

export default initialState;
